module.exports = __webpack_public_path__ + "static/media/6-love.52c415e3.mp3";